import {
  UpdateEvaluationFormTemplateDocument,
  UpdateEvaluationFormTemplateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateEvaluationFormTemplate = () => {
  const [updateForm, { loading }] = useMutation(UpdateEvaluationFormTemplateDocument, {
    extractorFn: (data) => data.atsMutations.updateAtsEvaluationForm,
  })

  return {
    loading,
    updateForm(variables: UpdateEvaluationFormTemplateMutationVariables) {
      return updateForm({
        variables,
      })
    },
  }
}
